'use strict';

bbw.directive.bbwContestList = function() {
    return {
        restrict: 'A',
        scope: {
            'contests': '=bbwContestList',
            'ctrl': '=',
            'className': '@'
        },
        templateUrl: bbw.templateUrl('contest-list.html'),
        link: function(scope, element) {
            // pass
        }
    };
};
